class FilterAnimations {
    constructor() {
        this.filterTabs = document.querySelectorAll('.c-filter_tab');
        this.breakpoint = 992;
        this.scrollTriggers = [];
        
        if (this.filterTabs.length) {
            this.init();
        }
    }

    init() {
        // Only initialize if ScrollTrigger exists
        if (typeof ScrollTrigger !== 'undefined') {
            // Wait for page transition to complete
            if (document.body.classList.contains('page-transitioning')) {
                document.addEventListener('pageTransitionComplete', () => {
                    this.initScrollTriggers();
                });
            } else {
                this.initScrollTriggers();
            }
        }
    }

    initScrollTriggers() {
        // Use matchMedia to only apply this on screens larger than 991px
        ScrollTrigger.matchMedia({
            "(min-width: 992px)": () => {
                // Set initial state
                gsap.set(this.filterTabs, {
                    opacity: 0,
                    y: 20
                });

                // Create a timeline for staggered animation
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: '.c-section_property_filters',
                        start: 'bottom 100%',
                    }
                });

                // Add staggered animation to timeline
                tl.to(this.filterTabs, {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    stagger: 0.1,
                    ease: 'power2.out',
                    onComplete: () => {
                        gsap.set(this.filterTabs, { clearProps: "all" });
                    }
                });

                // Store the ScrollTrigger instance for cleanup
                this.scrollTriggers.push(tl.scrollTrigger);
            }
        });
    }

    destroy() {
        // Clean up ScrollTrigger instances when component is destroyed
        this.scrollTriggers.forEach(trigger => trigger.kill());
        this.scrollTriggers = [];
    }
}

export default FilterAnimations; 